module.exports = __webpack_public_path__ + "media/images/common/add_mycatalog-b61a2494b083db42e806f4a202d37d3f.png";